import React from "react";
import { css } from "emotion";
import { colors, textSizes } from "../styles/theme";

const TitleBlock = ({ title, subtitle, style }) => {
  return (
    <div className={`${style ? style : ""} ` + container}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  );
};

export default TitleBlock;

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  h1 {
    color: ${colors.titleColor};
    font-size: ${textSizes.title};
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    letter-spacing: 2px;
  }
  p {
    color: ${colors.subtitleColor};
    font-size: ${textSizes.subtitle};
    text-align: center;
    max-width: 240px;
    letter-spacing: 1px;
  }
`;
